const isDeprecatedChannelType = channelTypeRef => {
  return App.globalContext.deprecatedChannelList.includes(channelTypeRef);
};

export default { isDeprecatedChannelType };
